import { Component, OnInit } from '@angular/core';
import { CountryService } from '../../shared/services/country.service';
import { ZipCodeService } from '../../shared/services/zip-code.service';
import { Store } from '@ngrx/store';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, delay } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as actions from '../../core/actions/contact.actions';
import * as fromContact from '../../core/reducers/contact.reducer';
import { MessageService } from 'primeng/api';

export class Country {
  code: string;
  name: string;
    public toString = () : string => {
        return `Foo (id: ${this.name})`;
    }
}

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    providers: [
        MessageService
    ]
})
export class ContactComponent implements OnInit {
    navLinks = [
        { 
            label: 'Liste' ,
            path: 'list',  		
        },
    ];

    form: FormGroup;
    public countryCtrl = new FormControl();
    filteredCountries: Observable<Country[]>;
    countries: Country[] = [];
    datas: any[] = [];


    constructor(
        private zipCodeService: ZipCodeService,
        private countryService: CountryService,
        private fb: FormBuilder,
        private store: Store<any>,
        private messageService: MessageService) {
    }

    ngOnInit() {
        this.store.select(fromContact.selectOpenContacts).pipe(delay(0)).subscribe(state => {
            let navLinks = [
                { 
                    label: 'Liste' ,
                    path: 'list',      
                }
            ];
            
            navLinks = navLinks.concat(state.map(e => {
                return {
                  'label': e.name,
                  'path': 'view/' + e.id,
                  'id': e.id,
                    canBeDeleted: true
                  };
            }));        
            this.navLinks = navLinks;
        });   

        this.store.select(fromContact.selectContactError).subscribe(error => {
            console.log('error',error);
            if (error) {
      this.messageService.add({
        severity: "error",
        summary: 'Erreur',
        detail: error
      });

            }
        });
    }

    deleteTab(idx) {
        this.store.dispatch(new actions.CloseTabAction(idx));
    }  
}
